import { File } from '@components/fields/file/models/file';
import { SignData } from '@components/fields/file/models/signData';

/**
 * Класс файла для модуля данных
 *
 * @package Fields
 * @version 2.0
 * @author Bolotov I.P.
 * @since 17.05.2023
 * @copyright (c) Internet-Frigate {@link http://www.ifrigate.ru}
 */
export class FileFactor extends File {
    constructor(data: any) {
        super(data);

        if (data?.factor_id && Number(data?.factor_id)) {
            this._factorId = Number(data?.factor_id);
        }

        // Подписи к файлу
        if (data?.hasOwnProperty('signs') && Array.isArray(data.signs) && data.signs.length > 0) {
            data.signs.forEach((item) => {
                this.signs.push(new SignData(item));
            });
        }
    }
    protected readonly _factorId: number = null;
    /**
     * Массив подписей к файлу
     * @protected
     */
    protected readonly signs: SignData[] = [];

    public get factorId(): number | null {
        return this._factorId;
    }

    public get signList(): SignData[] {
        return this.signs;
    }
}
